module.exports = __webpack_public_path__ + "img/chevron.c47fd00b.svg";